import {
  BooleanInput,
  Create,
  DateInput,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRefresh,
  required,
  minValue,
  maxValue,
} from 'react-admin';
import { LABELS } from 'shared/constants/labels';
import { useState } from 'react';
import { httpClient } from 'shared/services/http-client';
import { API_BASE_URL_ADMIN } from 'shared/config';

export const PromocodesCreate = () => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [promocodeType, setPromocodeType] = useState<'amount' | 'percentage'>('amount');

  const handleSubmit = async (payload: any) => {
    try {
      console.log(payload);
      
      const url = `${API_BASE_URL_ADMIN}/promocodes`;

      await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          promocode: {
            quantity: 1,
            amount: payload.discountType === 'amount' ? payload.amount : undefined,
            percentage: payload.discountType === 'percentage' ? payload.percentage : undefined,
            expireDate: payload.expireDate,
            firstUseOnly: payload.firstUseOnly,
            code: payload.code,
            discountType: payload.discountType,
          }
        }),
      });

      notify('Промокод успешно создан', { type: 'success' });
      refresh();
    } catch (error: unknown) {
      notify('Ошибка при создании промокода', { type: 'error' });
      refresh();
    }
  };

  return (
    <Create title="Создать именной промокод">
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput 
          label={LABELS.promocodeCode} 
          source="code" 
          validate={[
            required(),
            value => {
              const regex = /^[0-9a-z]+(\.[0-9a-z]+)*?$/i;
              if (value && !regex.test(value)) {
                return 'Неверный формат промокода. Промокод должен состоять из букв и цифр, может содержать точки (не в начале и конце)';
              }
              return undefined;
            }
          ]}
          parse={value => value?.trim()}
          helperText="Используйте только латинские буквы, цифры и точки (точка не может быть в начале или конце)"
        />
        <SelectInput
          required
          value={promocodeType}
          onChange={(e) => setPromocodeType(e.target.value as 'amount' | 'percentage')}
          label={LABELS.promocodeType}
          source="discountType"
          choices={[
            { id: 'amount', name: 'С номинальном' },
            { id: 'percentage', name: 'С процентом' },
          ]}
          sx={{
            '& .RaImageField-image': {
              width: 300,
              height: 300,
              objectFit: 'cover',
            },
          }}
        />
        {promocodeType === 'amount' && 
          <NumberInput 
            label={LABELS.promocodeAmount} 
            source="amount"
            validate={[
              required(),
              minValue(100, 'Минимальная сумма промокода - 100'),
              maxValue(100000, 'Максимальная сумма промокода - 100 000')
            ]}
            helperText="Допустимые значения: от 100 до 100 000"
          />
        }
        {promocodeType === 'percentage' && 
          <NumberInput 
            label={LABELS.promocodePercentage} 
            source="percentage"
            validate={[
              required(),
              minValue(1, 'Минимальный процент скидки - 5%'),
              maxValue(100, 'Максимальный процент скидки - 100%')
            ]}
            helperText="Допустимые значения: от 5 до 100%"
          />
        }
        <DateInput 
          label={LABELS.promocodeExpireDate} 
          source="expireDate"
          validate={[
            required(),
            value => {
              const selectedDate = new Date(value);
              const today = new Date();
              today.setHours(0, 0, 0, 0); // Сбрасываем время до начала дня
              
              if (selectedDate <= today) {
                return 'Дата должна быть в будущем';
              }
              return undefined;
            }
          ]}
          helperText="Выберите дату в будущем"
        />
        <BooleanInput label={LABELS.promocodeFirstUseOnly} source="firstUseOnly" />
      </SimpleForm>
    </Create>
  );
};
